import React, { memo, useCallback } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import BookingFormStore from 'Stores/BookingFormStore';
import BookingDiscountCode from 'Components/Front/Booking/BookingDiscountCode';
import BookingLegalFields from 'Components/Front/Booking/BookingLegalFields';
import BookingFlowStatus from 'Components/Front/Booking/BookingFlowStatus';
import BookingUserFields from 'Components/Front/Booking/BookingUserFields';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
import { num, isTrue } from 'Shared/utilities';
const {
  app
} = window;
export default memo(function B2BFormBooking({
  ...props
}) {
  const submitting = BookingFormStore.useState(s => isTrue(s.submitting));
  const redirecting = BookingFormStore.useState(s => isTrue(s.redirecting));
  const completed = BookingFormStore.useState(s => isTrue(s.completed));
  const step = BookingFormStore.useState(s => s.step);
  const b2b = BookingFormStore.useState(s => isTrue(s.b2b));
  const validate = useCallback(function (e) {
    e?.preventDefault?.();
    BookingFormStore.update(function (store) {
      store.company_submit_form_id = uniqid();
    });
  }, []);
  if (step !== 1 || !b2b) return null;
  if (completed) {
    return /*#__PURE__*/React.createElement("div", {
      className: "c-form c-form--booking-centered"
    }, /*#__PURE__*/React.createElement(BookingFlowStatus, null), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center u-margin-top-20"
    }, /*#__PURE__*/React.createElement(Button, {
      href: "/",
      className: bemit('c-arrow-btn', ['primary'])
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Retourner \xE0 l'accueil"))));
  }
  const submit_loader = submitting || redirecting ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    action: action('CreateCompanyBooking'),
    method: "POST",
    className: "c-form c-form--booking-centered",
    onSubmit: validate
  }, /*#__PURE__*/React.createElement(BookingUserFields, null), /*#__PURE__*/React.createElement(BookingLegalFields, {
    bemit: props.bemit
  }), /*#__PURE__*/React.createElement(BookingFlowStatus, null), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary', 'round']) + ' u-block u-margin-top-25 u-margin-left-auto u-margin-right-auto',
    type: "submit"
  }, "Valider la r\xE9servation", submit_loader)));
});
